// extracted by mini-css-extract-plugin
export default {"container":"verification-loading-popup__container___zdpb9"};